export const editableStates = {
  Editable: "Editable",
  EditableFromSourceDocument: "EditableFromSourceDocument",
  NotEditable: "NotEditable"
};
